<div class="row mx-0" *ngIf="(!showshimmerloader && !aidata)">
  <div class="col d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center">
      <p class="mb-0 mr-3 font-weight-600 f-16 ai-text-gradient">Unlock Our AI-Powered Analysis!</p>
      <button data-testid="auto-app-ai-sourcing-insights-ai-button-1" class="wc-btn gradientbtn" (click)="generateai()"><i class="fa-regular  fa-wand-magic-sparkles mr-1"></i> Generate</button>
    </div>
    <div>
      <button data-testid="auto-app-ai-sourcing-insights-ai-button-2" class="ats-cta-btn w-100 border-0" (click)="requestInsightsExport()" >
        <i class="fa-solid fa-download mr-2" ></i>
        Export
      </button>
    </div>
  </div>
</div>
<div style="height: 130px;" *ngIf="showshimmerloader">
  <p class="f-16 font-weight-600 ai-text-gradient">Keep tight while we generate insightful summaries... </p>
  <div  class="shimmer-loader mb-1" style="height: 18px; border-radius: 14px; background-image: linear-gradient(102deg, #fff7fa 50%, #ffd8e5 80%);"></div>
  <div  class="shimmer-loader mb-1" style="height: 18px; border-radius: 14px; background-image: linear-gradient(102deg, #fff7fa 50%, #ffd8e5 80%);"></div>
  <div  class="shimmer-loader mb-1" style="height: 18px; border-radius: 14px; background-image: linear-gradient(102deg, #fff7fa 50%, #ffd8e5 80%);"></div>
  <div  class="shimmer-loader mb-1" style="height: 18px; border-radius: 14px; background-image: linear-gradient(102deg, #fff7fa 50%, #ffd8e5 80%);"></div>
</div>
<div class="p-3" *ngIf="aidata && !refreshAi">
  <div class="d-flex justify-content-between align-items-center w-100">
    <span class="f-16 font-weight-600 ai-text-gradient">Real-time Search Insights</span>
    <button data-testid="auto-app-ai-sourcing-insights-ai-button-3" class="ats-cta-btn border-0" style="width: fit-content !important;" (click)="requestInsightsExport()" [disabled]="(!totalcount || !insightsdata)" [ngClass]="{'disabl-button': (!totalcount || !insightsdata)}">
      <i class="fa-solid fa-download mr-2" [ngClass]="{'text-9696': (!totalcount || !insightsdata)}"></i>
      Export
    </button>
  </div>
  <hr>
  <div class="d-flex justify-content-between w-100">
    <div #tta class="textBox2 d-flex flex-wrap" style="row-gap: 10px; column-gap: 10px;" [class.viewMore2]="viewMore2">
      <div [innerHtml]="aidata"></div>
      <div>
        <p class="f-14" *ngIf="viewMore2"><span class="font-weight-500">Note: </span> This summary has been AI-generated and may not represent complete information</p>

      </div>
  </div>

</div>
<div class="text-center m-auto pt-3">
  <button data-testid="auto-app-ai-sourcing-insights-ai-button-4"  class="f-14 font-weight-500 text-webbtree-green text-right pointer reg-btn" (click)="viewMore2 = !viewMore2">{{ viewMore2 ? 'View less': 'View More' }} <i class="far f-14 font-weight-500" [ngClass]="viewMore2 ? 'fa-angle-up': 'fa-angle-down'"></i>
  </button>
</div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
